import React, { useEffect, useState, useContext, useCallback } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import UserContext from "../context/UserContext";
import StripePay from "./StripePay";
import { api } from "../utils/apiHelper";
import "../styles/CheckOut.css";
//rock queen
const stripePromise = loadStripe("pk_live_51Rce3SAiBftvH423MIGBNy4l080OCs812VSiItIzcy2zZAc5zxBFcuU8fcp9Y0uJumOMygGwkaxnmKV4aTbHaeh200Gp46JiDc");

const CheckOut = () => {
  const { authUser } = useContext(UserContext);
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [showPaymentForm, setShowPaymentForm] = useState(false);
  const [purchaseSuccess, setPurchaseSuccess] = useState(false);
  const [purchaseMessage, setPurchaseMessage] = useState("");

  const fetchCart = useCallback(async () => {
    try {
      const data = await api(`/cart/${authUser._id}`);
      if (Array.isArray(data)) {
        setCartItems(data);
        const calcTotal = data.reduce((sum, item) => sum + parseFloat(item.price), 0);
        setTotal(calcTotal);
      } else {
        console.error("Unexpected cart response format:", data);
      }
    } catch (error) {
      console.error("Error fetching cart:", error);
    } finally {
      setLoading(false);
    }
  }, [authUser._id]);

  useEffect(() => {
    if (authUser && authUser._id) {
      fetchCart();
    }
  }, [authUser, fetchCart]);

  const handleProceedToPayment = () => {
    setShowPaymentForm(true); // only toggles form now
  };

  const handlePaymentSuccess = async (message) => {
    setShowPaymentForm(false);
    setPurchaseSuccess(true);
    setPurchaseMessage(message || "");
    await fetchCart(); // Refetch to reflect cleared cart
  };

  if (loading) return <p>Loading your cart...</p>;
  if (!cartItems.length && !purchaseSuccess) return <p className="myCart">Your cart is empty.</p>;

  return (
    <div className="check-container">
      <h2 className="myCart">Your Cart</h2>

      {purchaseSuccess && (
        <div className="success-message">
          ✅ {purchaseMessage || "Thank you for your purchase! Your items are now available."}
        </div>
      )}

      {!purchaseSuccess && (
        <>
          <ul className="files-list-order">
            {cartItems.map((item, index) => (
              <li key={`${item.projectId}-${index}`} className="product-card">
                <h3>{item.projectTitle}</h3>
                <p><strong>Seller:</strong> {item.ownerUsername || item.ownerId}</p>
                <p><strong>Category:</strong> {item.productCat}</p>
                <p><strong>Price:</strong> ${item.price}</p>
                {item.quantityAvailable !== null && (
                  <p><strong>Quantity Available:</strong> {item.quantityAvailable}</p>
                )}
                <p><strong>Added:</strong> {new Date(item.addedAt).toLocaleString()}</p>
              </li>
            ))}
          </ul>

          <div className="checkout-total">
            <p><strong>Total:</strong> ${total.toFixed(2)}</p>
            {!showPaymentForm && (
              <button className="add-to-cart-button" onClick={handleProceedToPayment}>
                Proceed to Payment
              </button>
            )}
          </div>

          {showPaymentForm && (
            <Elements stripe={stripePromise}>
              <StripePay
                total={total}
                cartItems={cartItems}
                authUser={authUser}
                onPaymentSuccess={handlePaymentSuccess}
              />
            </Elements>
          )}
        </>
      )}
    </div>
  );
};

export default CheckOut;
